// src/components/products/ProductForm/GeneralInfoSections/PoliciesSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const PoliciesSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Cancellation Policy - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="سياسة الإلغاء والتعديل (عربي)"
                        type="editor"
                        name="cancellation_and_change_policy_ar"
                        value={formData.cancellation_and_change_policy?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange(
                                'cancellation_and_change_policy',
                                'ar',
                                e.target.value
                            )
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.cancellation_and_change_policy_ar}
                        helperText={errors.cancellation_and_change_policy_ar}
                    />
                </Grid>
            )}

            {/* Cancellation Policy - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Cancellation and Change Policy (English)"
                        type="editor"
                        name="cancellation_and_change_policy_en"
                        value={formData.cancellation_and_change_policy?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange(
                                'cancellation_and_change_policy',
                                'en',
                                e.target.value
                            )
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.cancellation_and_change_policy_en}
                        helperText={errors.cancellation_and_change_policy_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default PoliciesSection;
